/* Speedy Food — Search overlay full-screen (consumer ecommerce style).
   - Loads /assets/products-index.json (~112 SKU with image URLs)
   - Live fuzzy substring match su title + linea + categoria
   - Mostra grid card prodotti con thumbnail mentre l'utente digita
   - Niente keyboard navigation (consumer UX, no IDE-style)
   - ESC + click su close button + click su overlay backdrop chiudono
*/
(function() {
  const overlay = document.querySelector('[data-search-modal]');
  if (!overlay) return;
  const openBtns = document.querySelectorAll('[data-search-open]');
  const closeBtns = overlay.querySelectorAll('[data-search-close]');
  const input = overlay.querySelector('[data-search-input]');
  const resultsEl = overlay.querySelector('[data-search-results]');
  const quickEl = overlay.querySelector('[data-search-quick]');
  const hintEl = overlay.querySelector('[data-search-hint]');
  const suggestBtns = overlay.querySelectorAll('[data-search-suggest]');

  let products = null;
  let debounceTimer = null;

  async function loadProducts() {
    if (products !== null) return products;
    try {
      // Shopify serves theme assets only from the CDN (not the storefront /assets/ path),
      // so use the asset_url passed via data-search-index; fall back to the relative path.
      const indexUrl = overlay.dataset.searchIndex || '/assets/products-index.json?v=3';
      const res = await fetch(indexUrl);
      products = await res.json();
    } catch (e) {
      products = [];
    }
    return products;
  }

  function open() {
    overlay.hidden = false;
    document.body.classList.add('is-search-locked');
    setTimeout(() => {
      if (input && input.focus) input.focus({ preventScroll: true });
    }, 60);
    loadProducts();
  }
  function close() {
    overlay.hidden = true;
    document.body.classList.remove('is-search-locked');
    if (input) input.value = '';
    if (resultsEl) resultsEl.innerHTML = '';
    if (quickEl) quickEl.style.display = '';
    if (hintEl) hintEl.style.display = '';
  }

  function search(query) {
    if (!products || products.length === 0) return [];
    const q = (query || '').toLowerCase().trim();
    if (q.length < 2) return [];
    const tokens = q.split(/\s+/);
    return products
      .map(p => {
        const haystack = (p.t + ' ' + p.l + ' ' + p.c).toLowerCase();
        let score = 0;
        for (const tok of tokens) {
          if (haystack.includes(tok)) {
            score += tok.length;
            if (p.t.toLowerCase().includes(tok)) score += 10;
          }
        }
        // Pos boost — prodotti più "in posizione" hanno score più alto
        if (score > 0) score += (p.p || 0);
        return { p, score };
      })
      .filter(x => x.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 12)
      .map(x => x.p);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function renderEmpty() {
    resultsEl.innerHTML = `
      <div class="search-overlay__empty">
        <h3 class="search-overlay__empty-title">Nessun risultato per quella ricerca.</h3>
        <p class="search-overlay__empty-body">Possiamo aiutarti noi a trovare il prodotto giusto.</p>
        <a class="search-overlay__empty-cta" href="/pages/richiedi-consulenza">Richiedi consulenza →</a>
      </div>`;
  }

  function renderResults(items) {
    if (!items || items.length === 0) {
      if ((input.value || '').trim().length >= 2) {
        renderEmpty();
      } else {
        resultsEl.innerHTML = '';
      }
      return;
    }
    const html = items.map((p, idx) => {
      const cat = escapeHtml(p.c || '');
      const title = escapeHtml(p.t || '');
      const _lp = (p.l || '').split(' · ');
      const linea = escapeHtml(_lp.length > 2 ? (_lp[0] + ' · ' + _lp[_lp.length - 1]) : (p.l || ''));
      const img = p.i ? `style="background-image:url('${escapeHtml(p.i)}')"` : '';
      const delay = Math.min(idx, 8) * 30;
      return `
        <a class="search-overlay__result" href="/products/${escapeHtml(p.h)}" style="animation-delay:${delay}ms">
          <div class="search-overlay__result-img" ${img}></div>
          <div class="search-overlay__result-body">
            ${cat ? `<div class="search-overlay__result-cat">${cat}</div>` : ''}
            <div class="search-overlay__result-title">${title}</div>
            ${linea ? `<div class="search-overlay__result-linea">${linea}</div>` : ''}
          </div>
        </a>`;
    }).join('');
    resultsEl.innerHTML = html;
  }

  function update() {
    const q = (input.value || '').trim();
    if (q.length === 0) {
      // Empty state — show quick categories
      if (quickEl) quickEl.style.display = '';
      if (hintEl) hintEl.style.display = '';
      resultsEl.innerHTML = '';
      return;
    }
    if (q.length < 2) {
      // Too short — keep quick categories visible
      if (quickEl) quickEl.style.display = '';
      resultsEl.innerHTML = '';
      return;
    }
    // Active search — hide quick chips, show results
    if (quickEl) quickEl.style.display = 'none';
    if (hintEl) hintEl.style.display = 'none';
    renderResults(search(q));
  }

  function onInput() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(update, 80);
  }

  // Wire openers
  openBtns.forEach(b => b.addEventListener('click', e => { e.preventDefault(); open(); }));
  // Wire closers
  closeBtns.forEach(b => b.addEventListener('click', e => { e.preventDefault(); close(); }));
  // Wire input
  if (input) input.addEventListener('input', onInput);
  // Wire suggest chips → fill input + run search
  suggestBtns.forEach(b => b.addEventListener('click', () => {
    if (!input) return;
    input.value = b.getAttribute('data-search-suggest') || '';
    update();
    input.focus({ preventScroll: true });
  }));

  // ESC closes
  document.addEventListener('keydown', e => {
    if (overlay.hidden) return;
    if (e.key === 'Escape' || e.key === 'Esc') close();
  });
})();
